import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const subsetArray = response => {
  return Object.fromEntries(
    Object.entries(response).map(([key, data]) => [
      key,
      data.filter((_, i) => i % 10 == 0)
    ])
  );
};

export default new Vuex.Store({
  state: {
    patientData: {},
    patientMutations: {},
    thisPatient: {},
    elnClassification: {},
    newClassification: {},
    averageRisk: {},
    thisPatientLoading: false,
    elnLoading: false,
    newLoading: false,
    averageLoading: false,
    isSidebarVisible: true,
    predictError: 0,
    confidenceIntervals: {
      // Cached
      age: [21.7467488022, 73],
      bm_blasts: [12, 98],
      hb: [5.1499977, 85],
      plt: [10, 301],
      wbc: [0.9, 201.5]
    }
  },
  getters: {
    patientData: state => state.patientData,
    patientMutations: state => state.patientMutations,
    thisPatient: state => state.thisPatient,
    averageRisk: state => state.averageRisk,
    newClassification: state => state.newClassification,
    elnClassification: state => state.elnClassification,
    newCategory: state => state.newClassification.NEW_classification || "",
    elnCategory: state => state.elnClassification.eln_classification || "",
    newPrincipleComponent: state =>
      state.newClassification.principle_component || "",
    thisPatientLoading: state => state.thisPatientLoading,
    elnLoading: state => state.elnLoading,
    newLoading: state => state.newLoading,
    averageLoading: state => state.averageLoading,
    isSidebarVisible: state => state.isSidebarVisible,
    hasResults: state =>
      !!Object.keys(state.newClassification).length ||
      !!Object.keys(state.elnClassification).length ||
      !!Object.keys(state.thisPatient).length,
    predictError: state => state.predictError,
    confidenceIntervals: state => state.confidenceIntervals
  },
  mutations: {
    updatePatientData(state, patientData) {
      state.patientData = { ...patientData };
    },
    updatePatientMutations(state, patientMutations) {
      state.patientMutations = { ...patientMutations };
    },
    updateThisPatient(state, response) {
      state.thisPatient = response;
    },
    updateNewClassification(state, response) {
      state.newClassification = response;
    },
    updateElnClassification(state, response) {
      state.elnClassification = response;
    },
    updateAverageRisk(state, response) {
      state.averageRisk = subsetArray(response);
    },
    setThisPatientLoading(state, value) {
      state.thisPatientLoading = value;
    },
    setElnLoading(state, value) {
      state.elnLoading = value;
    },
    setNewLoading(state, value) {
      state.newLoading = value;
    },
    setAverageLoading(state, value) {
      state.averageLoading = value;
    },
    toggleSidebar(state) {
      state.isSidebarVisible = !state.isSidebarVisible;
    },
    updatePredictError(state, value) {
      state.predictError = value;
    },
    setConfidenceIntervals(state, value) {
      state.confidenceIntervals = value;
    }
  },
  actions: {}
});
